/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Group, Button, TextField, InlineMessage } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/codeselector/codeselector_styles';



/* ========== ~~~~~~~~~~ EMBED : CODE SELECTOR : CONTAINER ~~~~~~~~~~ ========== */
const CodeSelector = (props) => {
    const handleFieldFocus = (e) => {
        e.target.select();
        document.execCommand('copy');
    };
    const handleButtonClick = (e) => {
        const codeField = e.target.closest('.group').querySelector('input');
        codeField.select();
        document.execCommand('copy');
    };
    const _renderCodePlacement =() => {
        switch(props.type) {
            case 'websitecode':
                return (
                    <div className={`codeselector ${props.classes.codeselector}`}>
                        <div className={`codepiece`}>
                            <h3>Header Code</h3>
                            <p>Place the following code right after the <strong>{`<head>`}</strong> tag in your HTML source code.</p>
                            <Group>
                                <TextField type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.headerCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`Copy`} />
                            </Group>
                        </div>
                        <div className={`codemessage`}>
                            <InlineMessage key={'meow'}
                                           display={true}
                                           name={'headercode'}
                                           variant={'neutral'}
                                           icon={'exclamation-triangle'}
                                           title={null}
                                           message={<span><strong>Insticator Header Code</strong> is the same for all ‘hard-coded’ embed and commenting widgets – <strong>only add it to your site once.</strong><br/>DFP embeds do require their own header code.</span>}
                                           close={false}
                                           handleClose={null} />
                        </div>
                        <div className={`codepiece`}>
                            <h3>Embed Code</h3>
                            <p>Place the following code inside of the <strong>{`<body>`}</strong> tag in your HTML source code.</p>
                            <Group>
                                <TextField type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.bodyCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`Copy`} />
                            </Group>
                        </div>
                    </div>
                );
            case 'dfp':
            default:
                return(
                    <div className={`codeselector ${props.classes.codeselector}`}>
                        <div className={`codepiece`}>
                            <h3>DFP Code</h3>
                            <p>Add the combined header and embed code into your <strong>DFP server</strong>.</p>
                            <Group>
                                <TextField type={`text`} name={`code`} handleFocus={handleFieldFocus} readOnly={true} value={props.headerCode + props.bodyCode} />
                                <Button type={`custom`} handleClick={handleButtonClick} variant={`primary`} name={`copy`} text={`Copy`} />
                            </Group>
                        </div>
                        <div className={`codemessage`}>
                            <InlineMessage key={'meow'}
                                           display={true}
                                           name={'headercode'}
                                           variant={'neutral'}
                                           icon={'exclamation-triangle'}
                                           title={null}
                                           message={<span>Please make sure <span className={`highlight`}>Serve into a SafeFrame</span> option is <strong>UNCHECKED</strong> in your DFP creative. It is checked by default, so you will need to manually uncheck it.</span>}
                                           close={false}
                                           handleClose={null} />
                        </div>
                    </div>
                )
        }
    };
    return(
        _renderCodePlacement()
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CodeSelector);
